import { defineStore } from 'pinia';
import { formModule } from '@/stores/form';

export const useFlsaSettingsForm = defineStore('flsaSettingsForm', () => formModule({
  fields: {
    flsa_survey_cycle_sla: {
      label: 'FLSA Survey Cycle SLA',
      rules: [
        { name: 'positiveInteger', errorMessage: 'Must be a whole number (e.g. 365)' },
      ],
    },
  },
}));
